import { authHeader,logout, handleResponse } from '../helpers';
import Vue from 'vue';


export const gerkService = {
    load,loadKMRS,loadHistory,save,loadWarrning,loadVse,loadGerkRKG,loadGerkZS
    
};

function load(sezona,pridelovalecid) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/gerk/?sezona=${sezona}&pridelovalecid=${pridelovalecid}`, requestOptions)
        .then(handleResponse)
        .then(gerk => {
            // login successful if there's a jwt token in the response
            
            return gerk;
        });
}


function save(gerk) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(gerk)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/gerk`, requestOptions).then(handleResponse);
}

function loadVse(sezona){

     const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/gerki?sezona=${sezona}`, requestOptions)
        .then(handleResponse)
        .then(gerk => {
            // login successful if there's a jwt token in the response
            
            return gerk;
        });
}

function loadWarrning(gerk,status){
    //in tu lahko napišem pravila ali pa jih enostavno potegnem iz baze preko api-ja
    //tu dodaj branje iz baze izplačil
    var opozorilo=false;
    if(status=="P"&&gerk.status!="P"&&gerk.status) 
        opozorilo=true;

    return new Promise((res,rej)=>{res({opozorilo:opozorilo,status:status,gerk:gerk,placiloStatus:gerk.status,razlog:"GERK je v preteklosti že dobil izplačilo za ukrep EK"})});

}

function loadKMRS(sezona,gerkpid) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/gerk/kmrs/?gerkpid=${gerkpid}&sezona=${sezona}`, requestOptions)
        .then(handleResponse)
        .then(kmrs => {
            // login successful if there's a jwt token in the response
            
            return kmrs;
        });
}


function loadGerkRKG(sezona,gerkpid) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/gerk/rkg/?gerkpid=${gerkpid}&sezona=${sezona}`, requestOptions)
        .then(handleResponse)
        .then(gerkRKG => {
            // login successful if there's a jwt token in the response
            
            return gerkRKG;
        });
}
function loadGerkZS(sezona,gerkpid) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/gerk/zs/?gerkpid=${gerkpid}&sezona=${sezona}`, requestOptions)
        .then(handleResponse)
        .then(gerkZS => {
            // login successful if there's a jwt token in the response
            
            return gerkZS;
        });
}


function loadHistory(gerkpid) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/gerk/zgodovina/?gerkpid=${gerkpid}`, requestOptions)
        .then(handleResponse)
        .then(history => {
            // login successful if there's a jwt token in the response
            
            return history;
        });
}

